import { Injectable } from '@angular/core';
import { ApplicationReady } from '@itero/itero-client-communication';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { BaseShellEvent, PublishEventFn } from './base-shell-event';

@Injectable({ providedIn: 'root' })
export class AppReadyEvent extends BaseShellEvent<ApplicationReady> {
	get eventName(): string {
		return ShellCommunicationEvents.AppReady;
	}

	handleCustomEvent(event: ApplicationReady, publishEventFunc?: PublishEventFn) {
		super.handleCustomEvent(event, publishEventFunc);
	}
}
